import { FuelUnit } from '@fe/core';
import { AltitudeUnit } from '../../common/enums';
import { FeServerRouteWaypointModel } from '../../messages/message-json';

export const ROUTE_ANALYZER_DEFAULT_LIGHT_COLOR = 'rgba(234,235,200,1)';
export const ROUTE_ANALYZER_DEFAULT_DARK_COLOR = 'rgba(51,51,42,1)';
export const ROUTE_ANALYZER_DEFAULT_POINT_COLOR = 'rgba(0,0,255,0.33)';

export const ROUTE_ANALYZER_DEFAULT_VERIFY_COLOR = 'rgba(8,228,228,1)';

export const MAX_VISIBLE_ROUTE_COUNT = 50;

export enum AnalyzerRouteType {
    company = 'C',
    preferred = 'P',
    cdr = 'D',
    swap = 'S',
    adhoc = 'A',
    flight = 'F',
    reroute = 'R',
    other = 'O',
    var = 'V',
    ovar = 'M',
    avar = 'E',
    released = 'L',
    filed = 'I',
    atc = 'T'
}

export interface AnalyzerRouteAssociatedPoint {
    enabled: boolean;
    label: string;
    latitude: number;
    longitude: number;
    range: number;
    color: string;
}

export interface AnalyzerRoute {
    id: string;
    routeKey?: string;
    type: AnalyzerRouteType;
    label: string;
    origin: string;
    destination: string;
    sequence: string;
    distance: number | null;
    ete: number | null;
    time: number | null;
    color: string;
    route: string;
    waypoints: {
        items: FeServerRouteWaypointModel[];
        altitudeUnits?: AltitudeUnit;
        fuelUnit?: FuelUnit;
    } | null;
    associatedPoints: AnalyzerRouteAssociatedPoint[];
    feedId: number | null;
    flightId?: number;
    visible: boolean;
}

/**
 * @deprecated Use MinimalAnalyzerRoute
 */
export interface ShortAnalyzerRoute {
    label: string | null;
    route: string;
    distance: number | null;
    origin: string | null;
    destination: string | null;
    sequence: string | null;
    type: AnalyzerRouteType | null;
}

// Used for adding routes to the analyzer from other components
export type MinimalAnalyzerRoute = Pick<AnalyzerRoute, 'route' | 'origin' | 'destination'> & {
    label: string | null;
    sequence: string | null;
    type: AnalyzerRouteType | null;
} & Partial<Omit<AnalyzerRoute, 'route' | 'origin' | 'destination' | 'label' | 'sequence' | 'type'>>;

export const RouteTypeToName: Record<AnalyzerRouteType, string> = {
    [AnalyzerRouteType.company]: 'Company',
    [AnalyzerRouteType.preferred]: 'Preferred',
    [AnalyzerRouteType.cdr]: 'CDR',
    [AnalyzerRouteType.swap]: 'SWAP',
    [AnalyzerRouteType.adhoc]: 'AdHoc',
    [AnalyzerRouteType.flight]: 'Flight',
    [AnalyzerRouteType.reroute]: 'ReRoute',
    [AnalyzerRouteType.other]: 'Other',
    [AnalyzerRouteType.var]: 'Var',
    [AnalyzerRouteType.ovar]: 'OVar',
    [AnalyzerRouteType.avar]: 'AVar',
    [AnalyzerRouteType.released]: 'Rel',
    [AnalyzerRouteType.filed]: 'Filed',
    [AnalyzerRouteType.atc]: 'ATC'
};
